import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

const PanelFooter = (props) => {
  const {
    toggleOption,
    isExpanded,
    isExpandable,
    moreOptionCount,
    togglePanel
  } = props

  const expandableContainerClassNames = classNames(
    'search-facet-panel-toggle', {
      'is-expanded': isExpanded && isExpandable
    }
  )

  const expandableToggleClassNames = classNames(
    'search-facet-panel-toggle__link', {
      'is-expanded': isExpanded && isExpandable
    }
  )

  const onSubmit = () => {
    togglePanel()
  }

  return (
    <div className={expandableContainerClassNames}>
      <a className={expandableToggleClassNames} href='' onClick={toggleOption}>
        <span>
          <span className='e-icon -icon-preview' />
          <span className='search-facet-panel-toggle__remaining'>
            Show remaining {moreOptionCount} options
          </span>
        </span>
        <span>Hide options</span>
      </a>
      <div className='search-facet-panel__action'>
        <button
          onClick={onSubmit}
          className='fds-c-button--3d -color-primary -width-full'
        >
          Done
        </button>
      </div>
    </div>
  )
}

PanelFooter.propTypes = {
  toggleOption: PropTypes.func.isRequired,
  togglePanel: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isExpandable: PropTypes.bool.isRequired,
  moreOptionCount: PropTypes.number.isRequired
}

export default PanelFooter



// WEBPACK FOOTER //
// ./client/components/filters/filtersPanel/panelFooter.js